import { render, staticRenderFns } from "./PosSetting.vue?vue&type=template&id=622c3f70&scoped=true&"
import script from "./PosSetting.vue?vue&type=script&lang=js&"
export * from "./PosSetting.vue?vue&type=script&lang=js&"
import style0 from "./PosSetting.vue?vue&type=style&index=0&id=622c3f70&prod&lang=css&"
import style1 from "./PosSetting.vue?vue&type=style&index=1&id=622c3f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c3f70",
  null
  
)

export default component.exports